<template>
    <div class="wrapper-title">
        <div class="title" v-if="!isApp && !isWeixin">
            <img src="@/assets/images/icon-back.png" class="icon" @click="handleGoBack" />
            <span>{{ title }}</span>
            <img src="@/assets/images/icon-share.png" class="icon" @click="handleShare" />
        </div>
        <div class="desc" :class="{ 'only-desc ': isApp || isWeixin }" v-html="desc"></div>
    </div>
</template>

<script>
import browser from '@/libs/browser';
import { DB_FXAN_BTN } from '@/libs/constant';

export default {
    name: '',
    computed: {
        title() {
            return this.$store.state.questionnaireTitle;
        },
        desc() {
            return this.$store.state.desc;
        },
        isApp() {
            return browser.isApp();
        },
        isWeixin() {
            return browser.isWeixin();
        }
    },
    data() {
        return {};
    },
    methods: {
        handleShare() {
            this.$track(DB_FXAN_BTN);
            this.$wxShare.shareTo('wechat');
        },
        handleGoBack() {
            console.log('dianji');
            window.location.reload();
        }
    }
};
</script>

<style scoped lang="scss">
.wrapper-title {
}
.title {
    position: fixed;
    top: 0;
    // width: 100%;
    width: 750px;
    z-index: 1000;
    background: #f87a3b8c;
    color: #fff;
    text-align: center;
    font-size: 36px;
    padding: 20px 32px 20px 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .icon {
        width: 45px;
        height: 45px;
    }
}
.desc {
    position: relative;
    color: #ffffffa3;
    text-align: center;
    font-size: 26px;
    padding: 90px 40px 0 40px;
}
.only-desc {
    margin-top: 30px;
    padding-top: 0;
}
</style>
